import type { ReactNode } from 'react'
import { cn, titleCase } from '@workflow/ui'

/**
 * A settings row, bare: what the thing is and why on the left, its control at
 * the right, separated by whitespace and the page's own rhythm — no boxes,
 * no outlines; the column of rows reads as one sheet. The title is a label,
 * so it reads in title case.
 */

export function SettingsRow({
  title,
  detail,
  children,
  className,
}: {
  title: string
  detail?: string
  children?: ReactNode
  className?: string
}) {
  return (
    <div className={cn('flex flex-col items-start justify-between gap-3 py-4 sm:flex-row sm:flex-wrap sm:items-center sm:gap-x-6', className)}>
      <div className="min-w-0 flex-1">
        <p className="text-ui text-foreground">{titleCase(title)}</p>
        {detail ? <p className="mt-0.5 text-caption text-muted-foreground">{detail}</p> : null}
      </div>
      {children ? <div className="max-w-full shrink-0">{children}</div> : null}
    </div>
  )
}
